import { render, staticRenderFns } from "./lookCargo.vue?vue&type=template&id=b40ef906&scoped=true&"
import script from "./lookCargo.vue?vue&type=script&lang=js&"
export * from "./lookCargo.vue?vue&type=script&lang=js&"
import style0 from "./lookCargo.vue?vue&type=style&index=0&id=b40ef906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40ef906",
  null
  
)

export default component.exports